/**
 * ОДИН ЗАПРОС НА ВСПЛЕСК (SCRUM-887).
 *
 * Владелец 29.10.2026: «тоже не мгновенно загружаются». ЗАМЕР на его стенде, страница райдеров, 218
 * райдеров, машина тихая, дев-сервер: `GET /api/shows` уходил ЧЕТЫРЕ раза (352, 119, 57, 80 мс),
 * `/users/me/account` — дважды, и всё это одновременно с `/riders/mine` (386 мс), за который человек
 * и ждёт. Сервер один и однопоточный, поэтому лишние запросы не «идут параллельно» — они отбирают
 * процессор у нужного.
 *
 * ПОЧЕМУ НЕ «ПОПРАВИТЬ ЗОВУЩИХ». Спрашивают независимые части страницы: значок входящих в меню,
 * баннер про непроверенную почту, гейт согласия с условиями, сама страница. Это правильно — они не
 * должны знать друг о друге. Договариваться им нужно не о том, КТО спросит, а о том, что на всплеск
 * уходит один запрос.
 *
 * ЭТО СКЛЕЙКА ВСПЛЕСКА, А НЕ КЕШ. Окно по умолчанию полторы секунды — столько живёт загрузка
 * страницы, и ровно столько, чтобы четыре спрашивающих получили один ответ. Дольше держать нельзя:
 * список офферов и шоу меняются от действий человека, и показать ему вчерашнее хуже, чем подождать.
 * Любая успешная ЗАПИСЬ на сервер забывает всё (`http.ts#authFetch`), поэтому «отправил оффер — и
 * вижу старый список» здесь невозможно.
 *
 * ОТВЕТ — ОДИН ОБЪЕКТ НА ВСЕХ СПРАШИВАЮЩИХ, и это правило для тех, кто его получает: НЕ ПРАВИТЬ
 * ПОЛУЧЕННОЕ НА МЕСТЕ. Отсортировал массив у себя — отсортировал и у соседа, который попросил тот же
 * список в то же окно. Копию здесь не делаем сознательно: `structuredClone` на каждый вызов стоит
 * дороже, чем сама склейка экономит, а правило соблюдается само, пока списки читают, а не
 * перекладывают (проверено по вызывающим; гарантии на будущее у правила нет — есть эта строка).
 * Найдено Линнеем при проверке PR 603.
 *
 * ОТКАЗ НЕ ЗАПОМИНАЕТСЯ: упавший запрос выбрасывается из памяти, следующий спрашивающий пробует
 * сам. Запомненный отказ означал бы, что одна потерянная сеть гасит страницу на полторы секунды.
 */
interface Entry {
  /** Время НАЧАЛА запроса: медленный ответ склеивает всех, кто пришёл, пока он летел. */
  at: number;
  value: Promise<unknown>;
}

const entries = new Map<string, Entry>();

export function sharedGet<T>(key: string, run: () => Promise<T>, ttlMs = 1500): Promise<T> {
  const now = Date.now();
  const have = entries.get(key);
  if (have && now - have.at < ttlMs) return have.value as Promise<T>;

  const value = run();
  const entry: Entry = { at: now, value };
  entries.set(key, entry);
  void value.catch(() => {
    if (entries.get(key) === entry) entries.delete(key);
  });
  return value;
}

/** Забыть всё. Зовётся после любой успешной записи на сервер — см. `http.ts#authFetch`. */
export function forgetShared(): void {
  entries.clear();
}
